import React from 'react';

import {
  Image,
} from '..';

const Icon = (props) => {
  return (
    <Image
      hover
      dimOnButtonParentHover
      transition="all 0.4s cubic-bezier(.25, .46, .45, .94)"
      {...props}
    />
  );
};

export default Icon;
